// Custom TailwindCSS modals for confirm dialogs
//
// Example usage:
//
//   <%= button_to "Delete", my_path, method: :delete, form: {
//     data: {
//       turbo_confirm: "Are you sure?",
//       turbo_confirm_description: "This will delete your record. Enter the record name to confirm.",
//       turbo_confirm_text: "record name"
//     }
//   } %>

function showConfirmModal(message, element, button) {
  // button is nil if using link_to with data-turbo-confirm
  let confirmText =
    button?.dataset?.turboConfirmText || element.dataset.turboConfirmText;
  let description =
    button?.dataset?.turboConfirmDescription ||
    element.dataset.turboConfirmDescription ||
    "";
  
  let confirmInput = "";
  if (confirmText) {
    confirmInput = `<input type="text" class="mt-4 form-control" data-behavior="confirm-text" />`;
  }
  
  let id = `confirm-modal-${new Date().getTime()}`;

  let content = `
      <el-dialog id="${id}-wrapper">
        <dialog id="${id}" class="fixed inset-0 m-0 h-full w-full max-h-none max-w-none overflow-y-auto bg-transparent backdrop:bg-transparent">
          <el-dialog-backdrop class="fixed inset-0 bg-gray-500/75 transition-opacity data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in dark:bg-gray-900/50"></el-dialog-backdrop>

          <div tabindex="0" class="flex min-h-full items-end justify-center p-4 text-center focus:outline-none sm:items-center sm:p-0">
            <el-dialog-panel class="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all data-closed:translate-y-4 data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-closed:sm:translate-y-0 data-closed:sm:scale-95 dark:bg-gray-800 dark:outline dark:-outline-offset-1 dark:outline-white/10">
              <h5 class="text-base font-semibold text-gray-900 dark:text-white">${message}</h5>
              <p class="mt-2 text-sm text-gray-500 dark:text-gray-400">${description}</p>

              ${confirmInput}

              <div class="flex justify-end items-center flex-wrap gap-3 mt-4">
                <button type="button" data-action="cancel" class="inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs inset-ring inset-ring-gray-300 hover:bg-gray-50 sm:w-auto dark:bg-white/10 dark:text-white dark:shadow-none dark:inset-ring-white/5 dark:hover:bg-white/20">Cancel</button>
                <button type="button" data-action="confirm" class="inline-flex w-full justify-center rounded-md bg-stone-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-stone-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-stone-600 sm:w-auto dark:bg-stone-500 dark:shadow-none dark:hover:bg-stone-400 dark:focus-visible:outline-stone-500">Confirm</button>
              </div>
            </el-dialog-panel>
          </div>
        </dialog>
      </el-dialog>
    `;

  document.body.insertAdjacentHTML("beforeend", content);
  let elDialog = document.getElementById(`${id}-wrapper`);
  let modal = document.getElementById(id);

  return new Promise((resolve) => {
    let confirmed = false;
    
    const cancelButton = modal.querySelector("[data-action='cancel']");
    const confirmButton = modal.querySelector("[data-action='confirm']");

    // Disable confirm button until the value matches confirmText
    if (confirmText) {
      confirmButton.disabled = true;
      modal
        .querySelector("input[data-behavior='confirm-text']")
        .addEventListener("input", (event) => {
          confirmButton.disabled = event.target.value != confirmText;
        });
    }

    cancelButton.addEventListener("click", () => {
      confirmed = false;
      elDialog.hide();
    }, { once: true });

    confirmButton.addEventListener("click", () => {
      confirmed = true;
      elDialog.hide();
    }, { once: true });

    elDialog.addEventListener(
      "close",
      () => {
        resolve(confirmed);
        // Clean up the dialog element after closing
        elDialog.remove();
      },
      { once: true }
    );

    // Open the dialog by setting the open attribute
    elDialog.setAttribute("open", "");

    // Focus on the cancel button after the dialog opens
    elDialog.addEventListener(
      "open",
      () => {
        cancelButton.focus();
      },
      { once: true }
    );
  });
}

// Handle form confirmations (button_to with data-turbo-confirm)
Turbo.config.forms.confirm = (message, element, button) => {
  return showConfirmModal(message, element, button);
};

// Handle link confirmations (link_to with data-turbo-confirm and data-turbo-method)
Turbo.setConfirmMethod((message, element) => {
  return showConfirmModal(message, element, null);
});
